import { gql } from '@apollo/client';

/**
 * Fragment for message fields
 */
export const MESSAGE_FRAGMENT = gql`
  fragment MessageFields on Message {
    id
    content
    sender
    createdAt
    messageType
    images
    files
    authorName
  }
`;

/**
 * Query to get company info and widget configuration
 */
export const GET_COMPANY_AND_CONFIG = gql`
  query GetCompanyAndConfig {
    companies {
      publicId
      name
      telegramBotUrl
    }
    widgetConfig {
      headerText
      headerSubtitle
      privacyPolicyUrl
      termsOfServiceUrl
      greeting
      knownUserGreeting
    }
  }
`;

/**
 * Query to get messages with cursor-based pagination
 */
export const GET_MESSAGES = gql`
  ${MESSAGE_FRAGMENT}
  query GetMessages($input: GetMessagesInput = {}) {
    messages(input: $input) {
      edges {
        node {
          ...MessageFields
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      chatTitle
      titleMessageId
    }
  }
`;
